// extracted by mini-css-extract-plugin
export default {"wrapper":"I1-z","play":"J1-z"};